import { ConnectionNames } from "../../../Contracts";
import { applyQueries } from "../../../Common";
import { OBQuerySubscribersStore } from "../../../C_OpenBets";
import { socketConnection } from "../SocketConnection";
let storage = {};
export function applyOpenBetsRPCQueries(message, meta) {
    const stringifiedMessage = JSON.stringify(message);
    if (storage[stringifiedMessage]) {
        return storage[stringifiedMessage];
    }
    const conn = socketConnection(message, meta);
    storage[stringifiedMessage] = new Promise((resolve, reject) => {
        conn.reject = reject;
        conn.resolve = resolve;
        applyQueries(OBQuerySubscribersStore, ConnectionNames.openBets, conn);
    }).finally(() => {
        promiseHandler(conn, stringifiedMessage);
    });
    return storage[stringifiedMessage];
}
function promiseHandler(conn, stringifiedMessage) {
    conn.deactivate();
    delete storage[stringifiedMessage];
    applyQueries(OBQuerySubscribersStore, ConnectionNames.openBets, conn);
}
//# sourceMappingURL=ApplyOpenBetsRPCQueries.js.map